<div class="modal-header">
  <h5 class="modal-title"
      id="addLocationModalLabel">Add location</h5>
  <button type="button"
          class="btn-close"
          aria-label="Close"
          (click)="activeModal.dismiss('Cross click')"></button>
</div>
<div class="modal-body">
  <form>
    <div>
      <label for="hotelCode"
             class="form-label">Hotel code: </label>
      <input class="form-control"
             id="hotelCode"
             type="text"
             [formControl]="hotelCodeForm" />
    </div>
  </form>
</div>
<div class="modal-footer">
  <button type="button"
          class="btn btn-secondary"
          (click)="activeModal.close('Close click')">Close</button>
  <button type="button"
          class="btn btn-primary"
          (click)="onSubmit()">Save location</button>
</div>